module.exports = __webpack_public_path__ + "img/play.c19ff9b6.svg";